import { supabase } from '../supabase';

export interface ProductViewData {
  productId: string;
  ipAddress?: string | null;
  userAgent?: string;
  referrer?: string;
}

export const trackProductView = async ({ productId, ipAddress, userAgent, referrer }: ProductViewData): Promise<boolean> => {
  try {
    // Call the stored procedure to increment the view count
    const { error } = await supabase.rpc('increment_product_view', {
      p_product_id: productId,
      p_ip_address: ipAddress ?? null,
      p_user_agent: userAgent ?? null,
      p_referrer: referrer ?? null
    });

    if (error) {
      console.error('Error tracking product view:', error);
      return false;
    }

    return true;
  } catch (err) {
    console.error('Unexpected error tracking product view:', err);
    return false;
  }
};

export const getProductViews = async (productId: string) => {
  try {
    const { data, error } = await supabase
      .from('digitalproducts')
      .select('view_count')
      .eq('id', productId)
      .single();

    if (error) {
      console.error('Error getting product views:', error);
      return 0;
    }

    return data?.view_count || 0;
  } catch (err) {
    console.error('Unexpected error getting product views:', err);
    return 0;
  }
};

export const getAllProductViews = async (creatorId: string) => {
  try {
    const { data, error } = await supabase
      .from('digitalproducts')
      .select('id, title, view_count')
      .eq('creator_id', creatorId);

    if (error) {
      console.error('Error getting all product views:', error);
      return [];
    }

    return data || [];
  } catch (err) {
    console.error('Unexpected error getting all product views:', err);
    return [];
  }
};